// -------------------------------------
//   SlickSlider
// -------------------------------------

jQuery(document).ready(function ($) {
    $('#slick-banner').slick({
        fade: false,
        arrows: true,
        dots: false,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    // Centralizar título quando não houver setas
    $(document).on('init breakpoint', '#slick-area', function(event){
        if ($('#slick-area-arrows').is(':empty')) {
            $('.home-area-block .section-title').addClass('title-full');
        } else {
            $('.home-area-block .section-title').removeClass('title-full');
        }
    });

    $('#slick-area').slick({
        infinite: false,
        speed: 300,
        arrows: true,
        appendArrows: $("#slick-area-arrows"),
        dots: false,
        lazyLoad: 'progressive',
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 840,
                settings: {
                    slidesToShow: 1,
                }
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    // Centralizar título quando não houver setas
    $(document).on('init breakpoint', '#slick-equipe', function(event){
        if ($('#slick-equipe-arrows').is(':empty')) {
            $('.home-equipe-block .section-title').addClass('title-full');
        } else {
            $('.home-equipe-block .section-title').removeClass('title-full');
        }
    });

    $('#slick-equipe').slick({
        infinite: false,
        speed: 300,
        arrows: true,
        appendArrows: $("#slick-equipe-arrows"),
        dots: false,
        lazyLoad: 'progressive',
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 840,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                }
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
});

//# sourceMappingURL=data:application/json;charset=utf8;base64,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
